import { Component } from '@angular/core';

@Component({
  selector: 'comp-card-buttons',
  templateUrl: 'card-buttons.component.html',
  styleUrls: ['card-buttons.component.scss'],
})
export class CardButtonsComponent {}
